// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fieldException: any = {
    travelingOut: 'travellingOut',
    travelingPlace: 'travellingCountry',
    employerAddress: 'employerStrtAddr',
    incomeIndividual: 'income',
    // syntax for backward compatiblity for field name updation
    // in pre-approval.json

    // latest_field_name:former_field_name
};
